var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingInfo"},[_c('BaseIcon',{attrs:{"icon":"icon-spinner","extraClass":"loadingInfo__icon"}}),_c('p',{staticClass:"loadingInfo__text"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }